import React from 'react';
import { getCountryFlag } from '../util/storage';

export default function Header({ user, onLogout, view, setView, showHealthPanel, showAdminUsers, welcomeMessage }) {
  return (
    <header className="header">
      <div className="header-left">
        <h1 className="app-title">VehicleStack</h1>
        {welcomeMessage && (
          <span style={{ marginLeft: '1rem', fontSize: '0.9rem', color: '#666' }}>
            {welcomeMessage}
          </span>
        )}
      </div>
      <nav className="header-nav">
        <button
          className={view === 'dashboard' ? 'active' : ''}
          onClick={() => setView('dashboard')}
        >
          Dashboard
        </button>
        <button
          className={view === 'vehicles' ? 'active' : ''}
          onClick={() => setView('vehicles')}
        >
          Vehicles
        </button>
        {showHealthPanel && (
          <button
            className={view === 'health' ? 'active' : ''}
            onClick={() => setView('health')}
          >
            Health
          </button>
        )}
        {showAdminUsers && (
          <button
            className={view === 'admin-users' ? 'active' : ''}
            onClick={() => setView('admin-users')}
          >
            Admin
          </button>
        )}
      </nav>
      <div className="header-right">
        <span className="user-info">
          <span className="user-flag">{getCountryFlag(user?.country_code)}</span>
          {user?.username || user?.name}
        </span>
        <button className="btn-secondary" onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
}
